import { render, staticRenderFns } from "./marketingIndex.vue?vue&type=template&id=1933a16b&scoped=true"
import script from "./marketingIndex.vue?vue&type=script&lang=js"
export * from "./marketingIndex.vue?vue&type=script&lang=js"
import style0 from "./marketingIndex.vue?vue&type=style&index=0&id=1933a16b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933a16b",
  null
  
)

export default component.exports